module.exports = __webpack_public_path__ + "static/media/mountadex-macbook-landing.11be047a.jpg";